import PropTypes from 'prop-types';
import React from 'react';

const AddUser = ({ className, onClick }) => (
  <svg
    className={className}
    onClick={onClick}
    viewBox="0 0 24 24"
    height="24"
    width="24"
    data-testid="addUserIcon"
  >
    <path
      d="M15 5.25C13.2051 5.25 11.75 6.70507 11.75 8.5C11.75 10.2949 13.2051 11.75 15 11.75C16.7949 11.75 18.25 10.2949 18.25 8.5C18.25 6.70507 16.7949 5.25 15 5.25ZM10.25 8.5C10.25 5.87665 12.3766 3.75 15 3.75C17.6234 3.75 19.75 5.87665 19.75 8.5C19.75 11.1234 17.6234 13.25 15 13.25C12.3766 13.25 10.25 11.1234 10.25 8.5ZM5 8.75C5.41421 8.75 5.75 9.08579 5.75 9.5V11.75H8C8.41421 11.75 8.75 12.0858 8.75 12.5C8.75 12.9142 8.41421 13.25 8 13.25H5.75V15.5C5.75 15.9142 5.41421 16.25 5 16.25C4.58579 16.25 4.25 15.9142 4.25 15.5V13.25H2C1.58579 13.25 1.25 12.9142 1.25 12.5C1.25 12.0858 1.58579 11.75 2 11.75H4.25V9.5C4.25 9.08579 4.58579 8.75 5 8.75ZM7.25 19.5C7.25 16.8766 9.37665 14.75 12 14.75H18C20.6234 14.75 22.75 16.8766 22.75 19.5V20.5C22.75 20.9142 22.4142 21.25 22 21.25C21.5858 21.25 21.25 20.9142 21.25 20.5V19.5C21.25 17.7051 19.7949 16.25 18 16.25H12C10.2051 16.25 8.75 17.7051 8.75 19.5V20.5C8.75 20.9142 8.41421 21.25 8 21.25C7.58579 21.25 7.25 20.9142 7.25 20.5V19.5Z"
      strokeLinecap="round"
    />
  </svg>
);

AddUser.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default AddUser;
